import { render, staticRenderFns } from "./GroupingTable.vue?vue&type=template&id=36d12746&"
import script from "./GroupingTable.vue?vue&type=script&lang=js&"
export * from "./GroupingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports